module.exports = __webpack_public_path__ + "static/media/a-2.32eff8a7.jpg";